/**
 * www page-shell min-height. `100vh` jumps when the mobile URL bar or
 * software keyboard shows; `100dvh` tracks the visible viewport.
 * CSS lives in `src/index.css` (`.min-h-www-shell`) with a `100vh` fallback.
 */
export const WWW_PAGE_SHELL_MIN_H_CLASS = 'min-h-www-shell';
